import React, { useState } from "react";
import styled from "styled-components";

// --- STYLED COMPONENTS ---

const FormWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-start; /* Do lewej strony */

`;

const FormContainer = styled.div`
  width: 100%;
  background-color: #f9f9f9;
  border: 1px solid #eee;
  padding: 60px 50px;
  display: flex;
  flex-direction: column;
  gap: 30px;
  box-sizing: border-box;

  @media (max-width: 768px) {
    padding: 40px 30px;
    border-left-width: 4px;
  }

  @media (max-width: 480px) {
    padding: 30px 20px;
  }
`;

const FormGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
`;

const FormLabel = styled.label`
  font-size: 0.85rem;
  font-weight: 700;
  text-transform: uppercase;
  color: #555;
  letter-spacing: 1px;
`;

const FormInput = styled.input`
  width: 100%;
  padding: 15px 20px;
  font-size: 1rem;
  color: #111;
  background-color: #fff;
  border: 1px solid #ddd;
  outline: none;
  font-family: inherit;
  transition: all 0.3s ease;
  box-sizing: border-box;

  &:focus {
    border-color: #111;
    background-color: #fff;
  }

  &::placeholder {
    color: #aaa;
  }
`;

const FormTextarea = styled.textarea`
  width: 100%;
  padding: 15px 20px;
  font-size: 1rem;
  color: #111;
  background-color: #fff;
  border: 1px solid #ddd;
  outline: none;
  font-family: inherit;
  resize: vertical;
  min-height: 150px;
  transition: all 0.3s ease;
  box-sizing: border-box;

  &:focus {
    border-color: #111;
    background-color: #fff;
  }

  &::placeholder {
    color: #aaa;
  }
`;

const SubmitButton = styled.button`
  align-self: flex-start; /* Do lewej */
  padding: 18px 50px;
  background-color: #111;
  color: #fff;
  border: 2px solid #111;
  font-size: 1rem;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 2px;
  cursor: pointer;
  transition: all 0.3s ease;
  margin-top: 10px;

  &:hover {
    background-color: #fff;
    color: #111;
  }

  &:disabled {
    background-color: #ccc;
    border-color: #ccc;
    color: #fff;
    cursor: not-allowed;
  }

  @media (max-width: 480px) {
    width: 100%;
    align-self: center;
  }
`;

const StatusMessage = styled.div`
  margin-top: 15px;
  font-size: 0.95rem;
  font-weight: 700;
  padding: 15px;
  border-left: 4px solid ${props => props.success ? "#28a745" : "#dc3545"};
  background-color: ${props => props.success ? "#f0fdf4" : "#fff5f5"};
  color: ${props => props.success ? "#155724" : "#721c24"};
`;

// --- KOMPONENT FUNKCYJNY ---

export const ContactForm = () => {
    const [email, setEmail] = useState("");
    const [title, setTitle] = useState("");
    const [message, setMessage] = useState("");
    const [status, setStatus] = useState(null); // { success: boolean, text: string }
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault(); // Zapobiega przeładowaniu strony, jeśli użyjesz <form>
        
        if (!email || !title || !message) {
            setStatus({ success: false, text: "Proszę wypełnić wszystkie pola." });
            return;
        }

        setIsSubmitting(true);
        setStatus(null);

        try {
            const res = await fetch("https://api.pth-hokej.pl/api/messages", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ email, title, content: message }),
            });

            if (res.ok) {
                setStatus({ success: true, text: "Wiadomość została wysłana pomyślnie. Odezwiemy się wkrótce!" });
                setEmail("");
                setTitle("");
                setMessage("");
            } else {
                const err = await res.json();
                setStatus({ success: false, text: err.error || "Wystąpił błąd podczas wysyłania." });
            }
        } catch (error) {
            console.error(error);
            setStatus({ success: false, text: "Błąd połączenia z serwerem. Spróbuj ponownie później." });
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <FormWrapper>
            <FormContainer as="form" onSubmit={handleSubmit}>
                
                <FormGroup>
                    <FormLabel>Adres E-mail</FormLabel>
                    <FormInput
                        type="email"
                        placeholder="np. jan.kowalski@email.com"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                    />
                </FormGroup>

                <FormGroup>
                    <FormLabel>Tytuł Wiadomości</FormLabel>
                    <FormInput
                        type="text"
                        placeholder="Czego dotyczy Twoja wiadomość?"
                        value={title}
                        onChange={(e) => setTitle(e.target.value)}
                        required
                    />
                </FormGroup>

                <FormGroup>
                    <FormLabel>Treść</FormLabel>
                    <FormTextarea 
                        placeholder="Napisz, w czym możemy Ci pomóc..."
                        value={message} 
                        onChange={(e) => setMessage(e.target.value)}
                        required
                    />
                </FormGroup>

                <SubmitButton type="submit" disabled={isSubmitting}>
                    {isSubmitting ? "Wysyłanie..." : "Wyślij Wiadomość"}
                </SubmitButton>

                {status && (
                    <StatusMessage success={status.success}>
                        {status.text}
                    </StatusMessage>
                )}

            </FormContainer>
        </FormWrapper>
    );
};